import { config } from '@iheartjane/config';
import { asyncFlagProvider } from '@iheartjane/feature-flags';
import '@iheartjane/reefer/styles/index.css';
import { initDatadogRum, initTrackJS } from '@iheartjane/tracking';
import { createRoot } from 'react-dom/client';

import { initMixpanel } from '@jane/shared/util';

import App from './app/App';

initTrackJS({
  application: config.trackJsApplication.replace('jane', 'business-admin'),
  forwardingDomain: config.trackJsDomain,
  token: config.trackJsToken,
  version: config.appVersion,
});

initMixpanel(config.businessMixpanelCustomerToken, {
  useLocalStorage: true,
});

initDatadogRum({
  allowedTracingUrls: [(url) => url.startsWith(config.businessUrl)],
  applicationId: config.businessDatadogAppId,
  clientToken: config.businessDatadogClientToken,
  service: 'business-admin',
  traceSampleRate: 50,
});

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

(async () => {
  /**
   * Use async flag provider so that the flags load before our app,
   * preventing any flicker.
   */
  const FlagProvider = await asyncFlagProvider({
    baseUrl: config.launchDarklyBaseUrl,
    clientSideID: config.businessLaunchDarklyClientID,
    eventsUrl: config.launchDarklyEventsUrl,
    streamUrl: config.launchDarklyStreamUrl,
  });

  root.render(
    <FlagProvider>
      <App />
    </FlagProvider>
  );
})();
